// src/config/index.js

const trim = (value) => {
  const text = String(value || '').trim();
  return text || '';
};

const devApiUrl = trim(process.env.REACT_APP_API_BASE_URL) || '/api';
// The standalone FastAPI app mounts its routes at /api. /api_v2 is the
// production nginx gateway prefix and does not exist when CRA talks directly
// to localhost:8000.
const devApiV2Url = trim(process.env.REACT_APP_API_V2_BASE_URL) || '/api';
const devWsUrl = trim(process.env.REACT_APP_WS_URL) || 'ws://localhost:8000';

const browserWsUrl = () => {
  if (typeof window === 'undefined' || !window.location || !window.location.host) {
    return '';
  }
  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
  return `${protocol}://${window.location.host}`;
};

const prodApiUrl = trim(process.env.REACT_APP_API_BASE_URL) || '/api';
const prodApiV2Url = trim(process.env.REACT_APP_API_V2_BASE_URL) || '/api_v2';
const prodWsUrl = trim(process.env.REACT_APP_WS_URL) || browserWsUrl();

const config = {
  development: {
    // Dev should talk directly to the standalone FastAPI service, not the legacy/nginx 8081 path.
    baseUrl: '',
    apiUrl: devApiUrl,
    apiV2Url: devApiV2Url,
    wsUrl: devWsUrl,
  },
  production: {
    // Production defaults are intentionally relative so the same build can be
    // tested on pinned blue/green hosts without calling the public prod host.
    baseUrl: '',
    apiUrl: prodApiUrl,
    apiV2Url: prodApiV2Url,
    wsUrl: prodWsUrl,
  }
}[process.env.NODE_ENV || 'development'] || {
  baseUrl: '',
  apiUrl: devApiUrl,
  apiV2Url: devApiV2Url,
  wsUrl: devWsUrl,
};

export default config;
